<!--
 * @Author: 窦云飞 df1987131@yeah.net
 * @Date: 2023-08-14 11:12:09
 * @LastEditors: 窦云飞 df1987131@yeah.net
 * @LastEditTime: 2023-08-23 09:52:00
 * @FilePath: /epec-bidding/Users/douyunfei/Documents/epec-ea/src/modules/projectA/components/product/productManage/batchAddProduct.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<!-- 批量新增商品 -->
<template>
  <div>
    <el-drawer
      title="规格选择"
      :visible.sync="drawerVisible"
      :direction="direction"
      :before-close="handleClose"
      :append-to-body="true"
      :show-close="false"
      :size="widthSize"
      class="dialog-content"
    >
      <div slot="title" class="title-wrap">
        <div class="title-txt">规格属性</div>
        <div>
          <eui-icon
            icon="eicon-close"
            color="#333"
            font-size="12px"
            @click="close"
          />
        </div>
      </div>
      <slot>
        <p>弹窗内容自定义</p>
      </slot>
      <div class="drawer-footer">
        <eui-btn type="secondary" @click="cancel">取消</eui-btn>
        <eui-btn v-debounce="submit">确定</eui-btn>
      </div>
    </el-drawer>
  </div>
</template>

<script>
export default {
  props: {
    drawerVisible: {
      type: Boolean,
      default: false
    },
    widthSize: {
      type: Number,
      default() {
        return 840;
      }
    }
  },
  data() {
    return {
      direction: 'rtl'
    };
  },

  components: {},

  computed: {},

  created() {},
  methods: {
    handleClose() {},
    close() {},
    cancel() {
      this.$emit('handleDrawerCancel', false);
    },
    submit() {
      this.$emit('handleDrawerSubmit');
    }
  }
};
</script>
<style lang="scss" scoped>
.dialog-content ::v-deep .el-drawer__header {
  padding: 13px 20px !important;
  background: rgba(245, 245, 245, 1) !important;
  margin-bottom: 20px !important;
}
.title-wrap {
  display: flex;
  flex-flow: row;
  justify-content: space-between;
  line-height: 1;
  align-items: center;
  .title-txt {
    font-size: 14px;
    color: #333;
    font-weight: 500;
  }
}
.drawer-footer {
  position: absolute;
  bottom: 0;
  text-align: center;
  /* display: flex; */
  /* justify-content: center; */
  width: 100%;
  /* left: 420px; */
  padding: 20px;
  background: #fff;
}
.dialog-content::v-deep.el-drawer__body {
  padding-left: 20px !important;
  padding-right: 20px !important;
}
.dialog-content::v-deep section {
  padding-left: 20px !important;
  padding-right: 20px !important;
}
</style>
